const CoverLetterIcon = () => {
    return (
        <svg width="33px" height="25px" viewBox="0 0 33 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPMobileChatThreadJobBoardCopy9" transform="translate(-54, -393)" stroke="#FFFFFF" strokeWidth="2">
                    <g id="Group8" transform="translate(55, 394)">
                        <line x1="5.48903971" y1="17" x2="24.3927" y2="17" id="Stroke5"></line>
                        <line x1="5.3927" y1="11" x2="24.392522" y2="11" id="Stroke7"></line>
                        <line x1="5.5009" y1="5.4726" x2="12.8669" y2="5.4726" id="Stroke9"></line>
                        <path d="M30.279,3.366 C30.279,1.514 28.869,0 27.147,0 L3.132,0 C1.409,0 0,1.514 0,3.366 L0,19.072 C0,20.923 1.409,22.438 3.132,22.438 L27.147,22.438 C28.869,22.438 30.279,20.923 30.279,19.072 L30.279,3.366 Z" id="Stroke1"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default CoverLetterIcon;
